const defaultManageQueriesRole = process.env.REACT_APP_ROLE_MANAGE_QUERIES ?? 'APMT.CDH.SelfService.Admin,APMT.CDH.SelfService.Editor';
const defaultViewRegionsRole = process.env.REACT_APP_ROLE_VIEW_REGIONS ?? 'APMT.CDH.SelfService.Admin';
const defaultCreateVersionsRole = process.env.REACT_APP_ROLE_CREATE_NEW_QUERY_VERSION ?? 'APMT.CDH.SelfService.Admin,APMT.CDH.SelfService.Editor';
const defaultActivateQueriesRole = process.env.REACT_APP_ROLE_ACTIVATE_QUERIES ?? 'APMT.CDH.SelfService.Admin';

const defaultAdminSchedulesRole = process.env.REACT_APP_ROLE_ADMIN_SCHEDULES ?? 'APMT.CDH.SelfService.Admin';
const defaultViewSchedulesRole = process.env.REACT_APP_ROLE_VIEW_SCHEDULES ?? 'APMT.CDH.SelfService.Admin,APMT.CDH.SelfService.Viewer';
const defaultAdminAgentsRole = process.env.REACT_APP_ROLE_ADMIN_AGENTS ?? 'APMT.CDH.SelfService.Admin';
const defaultViewAgentsRole = process.env.REACT_APP_ROLE_VIEW_AGENTS ?? 'APMT.CDH.SelfService.Admin,APMT.CDH.SelfService.Viewer';
const defaultViewDevDocsRole = process.env.REACT_APP_ROLE_VIEW_DEVELOPER_DOCS ?? 'APMT.CDH.SelfService.Admin,APMT.CDH.SelfService.Developer';
const defaultViewFaqRole = process.env.REACT_APP_ROLE_VIEW_FAQ ?? 'APMT.CDH.SelfService.Admin,APMT.CDH.SelfService.Developer';
const defaultManageCacheRole = process.env.REACT_APP_ROLE_MANAGE_CACHE ?? 'APMT.CDH.SelfService.Admin';
const defaultManageUserQuotaRole = process.env.REACT_APP_ROLE_MANAGE_USER_QUOTA
  ?? 'APMT.CDH.SelfService.SuperAdmin,APMT.CDH.SelfService.Super.Admin,APMT.CDH.SelfService.Super Admin';
const defaultExecuteDbBreakglassRole = process.env.REACT_APP_ROLE_EXECUTE_DB_BREAKGLASS ?? 'APMT.CDH.SelfService.DB.Breakglass.Executor';
const defaultViewServerRegistryRole = process.env.REACT_APP_ROLE_VIEW_SERVER_REGISTRY ?? 'APMT.CDH.SelfService.Admin';
const defaultManageServerRegistryRole = process.env.REACT_APP_ROLE_MANAGE_SERVER_REGISTRY ?? 'APMT.CDH.SelfService.Admin';
// Reference data is served by the standalone apmt-cdh-reference-data-service, which uses its own role set
// (APMT.CDH.ReferenceData.*). The existing SelfService roles are also accepted here so current users can
// see/open the feature during the transition; the backend still enforces the real ReferenceData.* roles.
const defaultViewRefDataRole = process.env.REACT_APP_ROLE_VIEW_REF_DATA ?? 'APMT.CDH.ReferenceData.View,APMT.CDH.ReferenceData.Write,APMT.CDH.ReferenceData.Admin,APMT.CDH.SelfService.Admin,APMT.CDH.SelfService.Editor,APMT.CDH.SelfService.Viewer,APMT.CDH.SelfService.SUPER.Admin';
const defaultManageRefDataRole = process.env.REACT_APP_ROLE_MANAGE_REF_DATA ?? 'APMT.CDH.ReferenceData.Write,APMT.CDH.ReferenceData.Admin,APMT.CDH.SelfService.Admin,APMT.CDH.SelfService.Editor,APMT.CDH.SelfService.SUPER.Admin';

// Helper function to split comma-separated roles into array
const splitRoles = (roleString: string): string[] => {
  return roleString.split(',').map(role => role.trim()).filter(role => role.length > 0);
};

export const roleConfig = {
  manageQueries: splitRoles(defaultManageQueriesRole),
  viewRegions: splitRoles(defaultViewRegionsRole),
  createVersions: splitRoles(defaultCreateVersionsRole),
  activateQueries: splitRoles(defaultActivateQueriesRole),
  adminSchedules: splitRoles(defaultAdminSchedulesRole),
  viewSchedules: splitRoles(defaultViewSchedulesRole),
  adminAgents: splitRoles(defaultAdminAgentsRole),
  viewAgents: splitRoles(defaultViewAgentsRole),
  viewDevDocs: splitRoles(defaultViewDevDocsRole),
  viewFaq: splitRoles(defaultViewFaqRole),
  manageCache: splitRoles(defaultManageCacheRole),
  manageUserQuota: splitRoles(defaultManageUserQuotaRole),
  executeDbBreakglass: splitRoles(defaultExecuteDbBreakglassRole),
  viewServerRegistry: splitRoles(defaultViewServerRegistryRole),
  manageServerRegistry: splitRoles(defaultManageServerRegistryRole),
  viewRefData: splitRoles(defaultViewRefDataRole),
  manageRefData: splitRoles(defaultManageRefDataRole),
};

export type RoleKey = keyof typeof roleConfig;

export const getRole = (key: RoleKey) => roleConfig[key];
